<template>
  <label :for="id" class="flex items-center cursor-pointer select-none">
    <input
      :id="id"
      type="checkbox"
      :checked="modelValue"
      @change="$emit('update:modelValue', $event.target.checked)"
      class="base-checkbox h-5 w-5 rounded border-2 border-primary-purple focus:ring-primary-purple focus:ring-2 transition duration-150 ease-in-out mr-2"
    />
    <span :class="['text-base font-medium text-gray-700', labelClass]">
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BaseCheckbox",
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    labelClass: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
});
</script>
